/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { Can as OriginalCan } from '@casl/react';
import { Ability } from '@casl/ability';

// Allow everything ability
const allowAllAbility = new Ability([{ action: 'manage', subject: 'all' }]);

function Can(props) {
  return <OriginalCan ability={allowAllAbility} {...props} />;
}

Can.propTypes = {
  I: PropTypes.string.isRequired,
  a: PropTypes.string,
  an: PropTypes.string,
  passThrough: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
};

export default Can;
